<template>
  <div class="flex flex-wrap justify-evenly space-x-2">
    <div
      v-for="priority in priorities"
      :key="priority.value"
      v-tooltip="capitalize(priority.value)"
      :data-cy="`priority-${priority.value}`"
      :class="[
        'flex cursor-pointer items-center justify-center rounded-full bg-grey-hover h-10 w-10',
        itemClasses,
        {
          'border border-primary': priority.value === modelValue,
        },
      ]"
      @click="setPriority(priority.value)"
    >
      <icon-base
        height="15"
        width="15"
        :view-box="priority.viewBox"
        :class="priority.class"
        :icon="priority.icon"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import capitalize from "lodash/capitalize";

import { priorities } from "@/helpers/constants/priorities";

import IconBase from "@/components/ui/IconBase.vue";

import type { Priority } from "@/models/applications";

const { itemClasses = "" } = defineProps<{
  itemClasses: string;
}>();

const model = defineModel<Priority>({ default: "none" });

const setPriority = (priority: string) => {
  model.value = priority as Priority;
};
</script>
